/**
 *
 * useControlPanel
 *
 */

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { EMBEDDED } from 'containers/App/constants';
import { useMinWidth } from 'utils/useMinSize';

function useControlPanel() {
  const minWidth = useMinWidth();
  const { pathname, hash } = useLocation();
  const [showControl, setShowControl] = useState(minWidth);
  const mapWrapper = document.getElementById('map-wrapper');
  const resetShowControl = () => setShowControl(minWidth);
  const toggleShowControl = () => setShowControl(f => !f);
  useEffect(resetShowControl, [pathname, hash]);
  useEffect(
    () => {
      if (EMBEDDED) {
        return;
      }
      if (mapWrapper) {
        if (showControl) {
          mapWrapper.classList.add('with-control');
        } else {
          mapWrapper.classList.remove('with-control');
        }
      }
    },
    [showControl, mapWrapper],
  );
  return { showControl, toggleShowControl, resetShowControl };
}

export default useControlPanel;
